/**
 * Redirige deep links sin prefijo /crm (enviados por el backend en correos de asignación)
 * a las rutas internas del CRM con prefijo /crm.
 * Contrato: backend redirige a /tasks/{id}, /calls/{id}, /opportunities/{id}, etc.
 */
import { Navigate, useParams } from 'react-router-dom';
import { NotFound } from '@/pages/NotFound';

type Segment = 'tasks' | 'calls' | 'opportunities' | 'contacts' | 'leads';

interface CRMDeepLinkRedirectProps {
  segment: Segment;
}

// Los deep links del backend siempre llevan un UUID (/leads/<uuid>, /tasks/<uuid>…).
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function CRMDeepLinkRedirect({ segment }: CRMDeepLinkRedirectProps) {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/crm" replace />;
  }

  // Solo tratamos el path como deep link CRM si el id es un UUID. Cualquier otro
  // slug (p.ej. una landing mal enlazada como /leads/irregular) NO debe colarse
  // en /crm/* y acabar enviando al visitante público al login de administración:
  // devolvemos 404 público.
  if (!UUID_RE.test(id)) {
    return <NotFound />;
  }

  // Llamadas: no hay vista de detalle por id, redirigir al manejador de llamadas
  if (segment === 'calls') {
    return <Navigate to="/crm/call" state={{ callId: id }} replace />;
  }

  return <Navigate to={`/crm/${segment}/${id}`} replace />;
}
